export const ATTRIBUTE_MODELS = [
  {
    id: 0,
    option: 'Conversation',
  },
  {
    id: 1,
    option: 'Contact',
  },
];

export const ATTRIBUTE_TYPES = [
  {
    id: 0,
    option: 'Text',
  },
  {
    id: 1,
    option: 'Number',
  },
  {
    id: 4,
    option: 'Link',
  },
  {
    id: 5,
    option: 'Date',
  },
  {
    id: 6,
    option: 'List',
  },
  {
    id: 7,
    option: 'Checkbox',
  },
  {
    id: 8,
    option: 'Multiselect',
  },
];

export const GROUP_TYPES = [
  {
    id: 0,
    option: 'text',
    label: 'TEXT'
  },
  {
    id: 1,
    option: 'Number',
    label: 'NUMBER'
  },
  {
    id: 2,
    option: 'currency',
    label: 'CURRENCY'
  },
];
